import { Dispatch, SetStateAction } from "react";

export default function SidebarExplorerItem({
  name,
  id,
  isSelected,
  onOpen,
  icon = "mdi-folder-outline",
}: {
  name: string;
  isSelected: boolean;
  id: string;
  onOpen: Dispatch<SetStateAction<string>>;
  icon?: string;
}) {
  return (
    <div
      className={`tw:flex tw:justify-between tw:items-center tw:hover:bg-ultralight tw:cursor-pointer  tw:rounded ${
        isSelected ? "bg-primary-selected tw:text-dark" : ""
      } tw:mx-3 tw:pl-2`}
      onClick={() => onOpen(id)}
    >
      <div className="tw:flex tw:items-center tw:w-full ">
        <i className={`mdi ${icon} tw:pr-2`} style={{ fontSize: 24 }} />
        <div className="tw:text-md tw:font-medium tw:truncate tw:flex-1 tw:select-none">
          {name}
        </div>
      </div>
    </div>
  );
}
